import React, { useContext } from "react"
import { useCurrentUser } from "../user/UserContext"

interface FeatureToggleContextProviderProps {
  children: React.ReactNode | React.ReactNodeArray
}

interface UseFeatureToggleReturn {
  showMultiYearCsd: boolean
  showCarrotPlansM15: boolean
}

const FeatureToggleContext = React.createContext(null)

export const useFeatureToggle = (): UseFeatureToggleReturn => useContext(FeatureToggleContext)

export function FeatureToggleContextProvider({ children }: FeatureToggleContextProviderProps): JSX.Element {
  const { email } = useCurrentUser()
  return (
    <FeatureToggleContext.Provider
      value={{
        showMultiYearCsd: email.includes("my+csd"),
        showCarrotPlansM15: true
      }}
    >
      {children}
    </FeatureToggleContext.Provider>
  )
}
